import React, { useState } from 'react';
import Header from './components/Header';
import Card from './components/Card';
import Card2 from './components/Card2';
import Playlist from './components/Playlist';
import Footer from './components/Footer';
import items from './assets/items';
import items2 from './assets/items2';

import './css/skeleton.css';
import './css/normalize.css';
import './css/components.css';

function App() {
  const [gridActive, setGridActive] = useState(false);

  return (
    <div className={`App ${gridActive ? 'show-structural-grid' : ''}`}>
      {/* Visual background grid pattern */}
      <div className="bg-grid-overlay"></div>

      <Header gridActive={gridActive} setGridActive={setGridActive} />

      {/* Primary Links Section */}
      <main className="main-content container">
        <div className="section-divider">
          <span className="divider-label">[01 // INDEXED_LINKS]</span>
          <div className="divider-line"></div>
        </div>

        <div className="cards-grid">
          {items.map((item, i) => {
            return (
              <Card
                key={i}
                i={i}
                title={item.title}
                subtitle={item.subtitle}
                link={item.link}
                cover={item.image}
              />
            );
          })}
        </div>

        {/* Featured Exhibit Section */}
        <div className="section-divider">
          <span className="divider-label">[02 // FEATURED_EXHIBIT]</span>
          <div className="divider-line"></div>
        </div>

        <div className="exhibit-section">
          {items2.map((item2, i2) => {
            return <Card2 key={i2} i2={i2} cover={item2.image} />;
          })}
        </div>

        {/* Audio / Music Stream Section */}
        <div className="section-divider">
          <span className="divider-label">[03 // AUDIO_BROADCAST]</span>
          <div className="divider-line"></div>
        </div>

        <div className="playlist-section">
          <Playlist />
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default App;